"use client";

import React from "react";
import PrimaryBtn from "@/components/PrimaryBtn";
import { useTheme } from "@/HomeFeatures/Context/ThemeContext";

// Forwards every PrimaryBtn prop except onClick, so server-component pages can
// render the exact same button they previously rendered inline. When `dark` is
// omitted, PrimaryBtn's own default (true) applies — identical to before.
type QuoteButtonProps = Omit<
  React.ComponentProps<typeof PrimaryBtn>,
  "onClick" | "iconSrc"
> & {
  iconSrc?: React.ComponentProps<typeof PrimaryBtn>["iconSrc"];
};

export default function QuoteButton({ iconSrc, ...props }: QuoteButtonProps) {
  const { handleOpenQuote } = useTheme();

  return (
    <PrimaryBtn
      {...props}
      iconSrc={iconSrc || ""}
      onClick={() => {
        handleOpenQuote();
      }}
    />
  );
}
